import type { SxProps, Theme } from '@mui/material'

export const styles = {
  boxWrapper: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
  },
  actionContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
  },
}

export const handleStylesWithProps =
  ({ toolbarWithBorder }: { toolbarWithBorder?: boolean }): SxProps<Theme> =>
  (theme) => ({
    borderTopLeftRadius: theme.spacing(1),
    borderTopRightRadius: theme.spacing(1),
    borderBottom: 0,
    ...(toolbarWithBorder && {
      borderWidth: 1,
      borderStyle: 'solid',
      borderColor: 'gray.12',
    }),
  })
